import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  emoji: '🍼',
  title: 'PASO A PASO REAL',
  desc: 'Instrucciones detalladas, fotos de cada textura y cantidades exactas. No adivinas nada. Como tener una nutricionista al lado.'
}, {
  emoji: '💰',
  title: 'LISTA DE COMPRAS EXACTA',
  desc: 'Compra solo lo que tu bebé va a comer. Sin desperdicio. Sin potitos caros. Sin compras impulsivas en el supermercado.'
}, {
  emoji: '📅',
  title: '500+ RECETAS · TODAS LAS ETAPAS',
  desc: 'Desde el primer puré a los 4 meses hasta el plato familiar a los 2 años. BLW, papillas, mixto — todo cubierto.'
}];
export function WhatsIncluded() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-white" data-id="element-199">
      <div className="max-w-6xl mx-auto" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-16" data-id="element-201">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D1F1A] tracking-tight" data-id="element-202">
            QUÉ <em className="text-[#F9A8B7] not-italic" data-id="element-203">INCLUYE</em>
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-204">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className={`${index === 1 ? 'bg-[#F0F8FB]' : 'bg-[#FFF1F4]'} p-6 md:p-8 rounded-3xl text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300`} data-id="element-205">
              <div className="text-5xl md:text-6xl mb-4 md:mb-6" data-id="element-206">
                {feature.emoji}
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#2D1F1A] mb-2 md:mb-4 leading-tight" data-id="element-207">
                {feature.title}
              </h3>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed" data-id="element-208">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}